<template>
  <div class="flex flex-wrap p-12">
    <img
      class="p-2 w-full md:w-1/3 cursor-pointer  object-cover hover:opacity-75"
      v-for="(image, i) in imgs"
      :key="i"
      :src="image"
      :alt="'Chata Luhačovice - obrázek ' + i"
      @click="index = i"
    />

    <VueEasyLightbox
      :imgs="imgs"
      :index="index"
      moveDisabled
      :visible="index !== null"
      @hide="index = null"
    >
    
        <template #toolbar></template>
    </VueEasyLightbox>
  </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";

export default {
  props: ["images"],

  components: {
    VueEasyLightbox,
  },

  data() {
    return {
      imgs: JSON.parse(this.images),
      index: null,
    };
  },
};
</script>
